const InstallmentStatus = {
    1: {
        label: 'Em Aberto',
        color: '#06BCED',
    },
    2: {
        label: 'Parcela paga',
        color: '#45D256',
    },
    3: {
        label: 'Em acordo',
        color: '#7740F9',
    },
    4: {
        label: 'Vencida',
        clor: '#7740F9',
    },
    5: {
        label: 'Renegociada',
        color: '#B7C7D2',
    },
    6: {
        label: 'Inativa',
        color: '#B7C7D2',
    },
};

export default InstallmentStatus;
